import { MultiLineTextPlaceholder } from "features/common/components/TextPlaceholder";

export default function Loading() {
  return (
    <MultiLineTextPlaceholder
      loading
      placeholderWidth="100%"
      placeholderHeight="50px"
      numberOfLines={4}
    />
  );
}
